import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  laptopAndAbove,
  mediumDesktopAndAbove,
} from '@sorare/core/src/style/mediaQuery';

import { CheckNbaTile } from '../CheckNbaTile';
import { ForYou } from '../ForYou';
import { OffseasonCountdownTile } from '../OffseasonCountdownTile';

const Wrapper = styled(Vertical)`
  min-height: calc(100vh - var(--current-stack-height));
`;

const TilesWrapper = styled(Vertical)`
  flex: 1;

  display: grid;
  grid-template-columns: 1fr;

  @media ${laptopAndAbove} {
    grid-template-columns: 2fr 0.9fr;
  }

  @media ${mediumDesktopAndAbove} {
    grid-template-columns: 2fr 0.9fr;
  }
`;

const ForYouWrapper = styled(Vertical)`
  max-width: 100vw;
  padding: var(--double-unit);

  @media ${laptopAndAbove} {
    padding: var(--double-unit) var(--double-unit) var(--double-unit) 0;
    & > :first-child {
      flex: 1;
      max-height: 510px;
      min-height: 300px;
    }
  }
`;

export const OffseasonPlayPage = () => {
  return (
    <Wrapper>
      <TilesWrapper>
        <OffseasonCountdownTile />
        <ForYouWrapper>
          <CheckNbaTile />
          <ForYou />
        </ForYouWrapper>
      </TilesWrapper>
    </Wrapper>
  );
};
